import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AuditTrialDetails } from '../../../../shared/models/audits/audit-trial-details';
import { SimpleChanges } from '@angular/core';
import { SharedConstants } from '../../../../shared/constants/shared-constants';

@Component({
  selector: 'app-user-profile-audit-trail',
  templateUrl: './user-profile-audit-trail.component.html',
  styleUrls: ['./user-profile-audit-trail.component.scss']
})
export class UserProfileAuditTrailComponent {

  @Input() auditTrailData: AuditTrialDetails[] = [];

  auditAttributeDetailsOfTransaction!: AuditTrialDetails;
  userProfileAuditSummaryDetails: AuditTrialDetails[] = [];
  isDataLoaded = false;

  constructor(private messageService: MessageService) {}

  ngOnInit(): void {
    this.initializeAuditData();
    console.log(this.auditTrailData);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['auditTrailData']) {
      this.initializeAuditData();
    }
  }

    private initializeAuditData(): void {
    if (this.auditTrailData && this.auditTrailData.length > 0) {
      this.userProfileAuditSummaryDetails = this.auditTrailData;
      this.auditAttributeDetailsOfTransaction = this.auditTrailData[0];
      this.isDataLoaded = true;
      this.notifyMissingAttributesIfAny();
    } else {
      this.userProfileAuditSummaryDetails = [];
      this.auditAttributeDetailsOfTransaction = undefined!;
      this.isDataLoaded = false;
    }
  } 

  showAuditItemDetails(auditAttributeDetails: AuditTrialDetails) {
    this.auditAttributeDetailsOfTransaction = auditAttributeDetails;
  }

  private hasMissingAttributes(): boolean {
    return !!this.userProfileAuditSummaryDetails?.some(d => d?.attributeDetails?.some(a => a?.isAttributeValueMissing));
  }

  private notifyMissingAttributesIfAny(): void {
    if (this.hasMissingAttributes()) {
      this.messageService.add({
        severity: SharedConstants.Severity_Warning,
        summary: SharedConstants.AuditTrail_AttributeMissing_Message,
        life: 20000,
      });
    }
  }
}
